exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_navigationBarContentWrapper_Y_hcGGfdaUQ4gQuCcpUZ8 {\n  display: flex;\n  height: 100%;\n  flex-direction: row-reverse;\n  align-Items: center;\n}\n\n.IA_templateEditorWrapper_1zgJvv2-p6esgYfiJvxsYU {\n  display: flex;\n  flex-direction: column;\n  padding: 0 40px;\n}\n\n.IA_createTemplateButtonWrapper_3llx2yYnNZyOnzILMKa2gD {\n  margin-top: 25px;\n}", ""]);

// Exports
exports.locals = {
	"IA_navigationBarContentWrapper": "IA_navigationBarContentWrapper_Y_hcGGfdaUQ4gQuCcpUZ8",
	"IA_templateEditorWrapper": "IA_templateEditorWrapper_1zgJvv2-p6esgYfiJvxsYU",
	"IA_createTemplateButtonWrapper": "IA_createTemplateButtonWrapper_3llx2yYnNZyOnzILMKa2gD"
};